import { Box, Button ,styled, Typography,ThemeProvider,createMuiTheme,keyframes} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';import {HashLink as Link } from 'react-router-hash-link';
import React from 'react'
import { Fade } from 'react-reveal';

const Wrapper=styled(Box)(({theme})=>({
    width:'100%',
    marginTop:'70px',
    color:'#4E5255',
    fontFamily:'cursive',
    display:'flex',
    background:'#f6f6f6',
    height:'470px',
    justifyContent:'center',
    paddingTop:'76px',
    padding: '98px 0px',
    [theme.breakpoints.down('md')]:{
      marginTop:'30px'
    }
  }))
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Lobster',
      'cursive',
    ].join(','),
  },});

  const MoveUpDown=keyframes`
  from{
    margin-top:16px;
  }to{
    margin-top:20px;
  }`;

  const Scroll=styled(KeyboardArrowDownIcon)`
  font-size:50px;
  `

const Home = () => {

  const viewResume=()=>{
    window.open('https://drive.google.com/file/d/1Rd4kY2Ti6TW90IMy33onRKPx8vnZmcbu/view?usp=sharing','_blank');
  }
  
  return (
    <ThemeProvider theme={theme}>
    <Wrapper id='Home'>
        <Box>
          <Box style={{display:'flex',justifyContent:'center'}}><img src='https://i.postimg.cc/nc0jVQYq/Ayush-Photo.jpg' alt='imagea' style={{width: '230px',borderRadius: '243px',height: '250px',boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}/></Box>
          <Box style={{textAlign: 'center',marginTop: '30px'}}>
            <Fade>
            <Typography style={{fontSize:'18px'}}>Hi! I am </Typography>
            </Fade>
            <Typography style={{fontSize: '66px',fontWeight: '600'}}>Ayush Singh</Typography>
            <Typography style={{fontSize:'18px'}}>Full Stack Web Developer</Typography>
          </Box>
          <Box style={{textAlign: 'center',marginTop: '20px'}}>
        <Button variant="contained" onClick={viewResume}>VIEW RESUME</Button>
        </Box>
        
        <Box style={{textAlign: 'center',marginTop: '16px',animation:`${MoveUpDown} 1s ease-in-out infinite`,position:'relative'}}>
        <Link to='#About' smooth style={{textDecoration:'none'}}>
          <Typography style={{fontFamily:'cursive'}}>Learn more</Typography>
        <Scroll style={{marginTop:'-15px'}} />
        </Link>
        </Box>
        </Box>
      </Wrapper>
      </ThemeProvider>

  )
}

export default Home
